<script>
  import { Button } from '../../components/ui'
  import { liveLabel, refreshLabel } from '../../lib/moderation_live.js'
  import RefreshRing from './refresh_ring.svelte'

  let { live, undoCount = 0, onUndoLast = () => {} } = $props()

  const IDLE_HINT = 'Auto-refresh stopped after 10 hours. Click Refresh to resume.'

  const stopped = $derived(live.paused || live.idle)
  const idleHint = $derived(live.idle && !live.paused ? IDLE_HINT : undefined)
</script>

<div class="flex items-center gap-2 flex-wrap">
  <span class="status {stopped ? 'status-neutral' : 'status-success animate-pulse'}" aria-hidden="true"></span>
  <strong class="text-sm" title={idleHint}>{liveLabel(live)}</strong>
  <RefreshRing lastUpdatedAt={live.lastUpdatedAt} paused={stopped} />

  <Button variant="ghost" size="sm" icon={live.paused ? 'play' : 'pause'} onclick={live.togglePaused}>
    {live.paused ? 'Resume' : 'Pause'}
  </Button>
  <Button variant="ghost" size="sm" icon="refresh" disabled={live.refreshing} title={idleHint} onclick={live.refresh}>
    {refreshLabel(live)}
  </Button>
  {#if undoCount > 0}
    <Button variant="ghost" size="sm" icon="undo" title="Undo the last submission review made from this feed" onclick={onUndoLast}>
      Undo last ({undoCount})
    </Button>
  {/if}
</div>
